import { Box } from "@mui/material";
import GetInTouchBlock from "./get_in_touch_block";
import ContactUsBlock from "./contact_us_block";

const ContactUs = () => {
  return (
    <Box sx={{ textAlign: "center", flexGrow: 1, pt: 2, pb: 2 }}>
      <ContactUsBlock />
      <GetInTouchBlock />
    </Box>
  );
};

export default ContactUs;
